var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgIllustratedFiles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 54,
    viewBox: "0 0 137 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.2168,
    width: 43.5758,
    height: 53.2593,
    rx: 4,
    fill: "#C2C7FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0586,
    y: 4.8418,
    width: 33.8923,
    height: 9.68351,
    rx: 2,
    fill: "#929BFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0586,
    y: 20.5781,
    width: 33.8923,
    height: 2.42088,
    rx: 1.21044,
    fill: "#929BFD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0586,
    y: 30.2617,
    width: 24.2088,
    height: 2.42088,
    rx: 1.21044,
    fill: "#929BFD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0586,
    y: 39.9453,
    width: 29.0505,
    height: 2.42088,
    rx: 1.21044,
    fill: "#929BFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9586 12.1355C87.3789 9.97584 89.4644 8.56103 91.6265 8.96889L102.227 10.9686C103.222 11.1564 104.11 11.715 104.709 12.5316L106.518 14.9946C107.118 15.8112 108.005 16.3698 109 16.5577L125.823 19.7311C127.994 20.1406 129.421 22.2324 129.012 24.4033L125.127 44.9997C124.71 47.2051 122.562 48.6367 120.366 48.1712L81.5477 39.9417L86.9586 12.1355Z",
    fill: "#C2C7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77 23.9663C92.6327 22.5341 94.2951 21.7894 95.9381 22.0994L130.373 28.5953C133.112 29.112 134.496 32.2018 133.058 34.5896L125.802 46.6361C124.94 48.0684 123.277 48.813 121.634 48.5031L84.7762 41.55L84.7764 39.1309L84.7762 35.5786L91.77 23.9663Z",
    fill: "#929BFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2167 9.73494C40.5608 9.50117 39.8352 9.43574 39.1024 9.58044L4.20051 16.472C2.03322 16.8999 0.623197 19.0038 1.05114 21.1711L5.9496 45.9791C6.37754 48.1464 8.48139 49.5564 10.6487 49.1285L41.2167 43.0927V9.73494ZM9.52631 20.3559C7.55878 20.7444 6.27872 22.6543 6.66722 24.6219C7.05572 26.5894 8.96566 27.8694 10.9332 27.4809C12.9007 27.0925 14.1808 25.1825 13.7923 23.215C13.4038 21.2474 11.4938 19.9674 9.52631 20.3559ZM15.4644 29.2178C16.3896 26.4016 19.9496 25.5351 22.0657 27.6109L24.2316 29.7357C25.7959 31.2702 28.4051 30.8137 29.3554 28.8391C30.3237 26.8271 33.0031 26.4006 34.5483 28.0125L38.7291 32.374C40.9166 34.6559 39.7176 38.4539 36.6164 39.0662L17.2466 42.8909C14.2452 43.4835 11.7166 40.6245 12.6716 37.7181L15.4644 29.2178Z",
    fill: "#929BFD"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustratedFiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustrated-files.343929babcf82d3324a278299baecbb5.svg";